export interface IBreadcrumb {
  name: string | number;
  icon?: string;
  link?: string;
}
